import { render, staticRenderFns } from "./RASuiteSubscriptions.vue?vue&type=template&id=16abfbee&"
import script from "./RASuiteSubscriptions.vue?vue&type=script&lang=js&"
export * from "./RASuiteSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports